import request from '@/utils/request'

const BASE_ROUTE = 'api/v1/inspection/'
export const getOrderTypes = () =>
  request({
    url: BASE_ROUTE + 'order-types',
    method: 'get'
  })

export const getInspTypes = () =>
  request({
    url: BASE_ROUTE + 'insp-types',
    method: 'get'
  })
